import { Label, Text, AvaSelect } from "@avanadeits/vangogh";

type Props = {
    id: string;
    label: string;
    position?: "top" | "right" | "left" | "bottom";
    isDisabled?: boolean;
    onChange: (e: any) => void;
    value: any;
    options: any[];
};

export const SimpleSelect = ({ position, label, ...props }: Props) => {
    return (
        <>
            <Label position={position}>
                <Label.Inner>
                    <Label.Header>
                        <Label.HeaderMain>
                            <Text>{label}</Text>
                        </Label.HeaderMain>
                    </Label.Header>
                    <Label.Body>
                        <AvaSelect {...props} />
                    </Label.Body>
                </Label.Inner>
            </Label>
        </>
    );
};
